module.exports = __webpack_public_path__ + "img/guideline.766e87b6.jpg";